// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"unauthorized_wrapper__fN50q","text":"unauthorized_text__dqTgw","actions":"unauthorized_actions__FBcQz"};